import { FunctionComponent, useMemo, useState } from 'react'

import ContainerPage from 'shared/components/ContainerPageNew'
import { IConsultZipCode } from 'modules/user/domain/usecases/ConsultZipCodeImpl'
import SnackBar from 'shared/components/SnackBar'

import { ICreateMotorista } from '../../domain/usecases/CreateMotoristaImpl'
import { useMotoristas } from '../../hooks/useMotoristas'

import Address from './components/Address'
import Phone from './components/Phone'
import Photo from './components/Photo'
import ReferenciasProfissionais from './components/ReferenciasProfissionais'
import Email from './components/Email'

type TProp = {
  createMotorista: ICreateMotorista
  consultZipCode: IConsultZipCode
}

const CreateMotorista: FunctionComponent<TProp> = ({
  createMotorista,
  consultZipCode,
}) => {
  const { step } = useMotoristas()
  const [error, setError] = useState(false)

  const componentSteps = useMemo(() => {
    return [
      { component: <Photo /> },
      { component: <Phone /> },
      { component: <Email /> },
      {
        component: <Address consultZipCode={consultZipCode} />,
      },
      {
        component: (
          <ReferenciasProfissionais createMotorista={createMotorista} />
        ),
      },
    ]
  }, [consultZipCode, createMotorista])

  return (
    <>
      <ContainerPage
        breadCrumb="Motoristas / Adicionar motoristas"
        showScaffold={false}
      >
        {componentSteps[step].component}
      </ContainerPage>
      <SnackBar
        open={error}
        setOpen={setError}
        severity="error"
        horizontal="right"
      />
    </>
  )
}

export default CreateMotorista
